import { Component, OnInit } from '@angular/core';
import { IUser } from '../../shared/classes/user';
import { SystemService } from '../../services/system.service';
import { MessageService, Message, ConfirmationService } from 'primeng/api';
import { CookieService } from 'ngx-cookie-service';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { Router } from '@angular/router';

@Component({
  templateUrl: './demosettings.component.html'
})
export class DemoSettingsComponent implements OnInit {

  appealsUserList: IUser[];
  myUser: IUser = {
    id: 0,
    emailAddress: '',
    firstName: '',
    lastName: '',
    userType: '',
    isActive: true,
    username: '',
    lastLoginDt: ''
    };
  myRole = '';
  userType: string;  // this is userType of logged on user for checking Read-Only
  userTypeList = [];
  userTypeListAssessor = ['Assessor', 'Assessor-Supervisor', 'Assessor-Manager'];
  userTypeListCoB = ['Administrator', 'Clerk of the Board', 'ReadOnly', 'Assessor-Manager'];
  userTypeListALL = ['Administrator', 'Clerk of the Board', 'ReadOnly', 'Assessor', 'Assessor-Supervisor', 'Assessor-Manager', 'Assessor-ReadOnly' ];

  isNewEntry = false;

  displayState: any = {
    workingDiv: false,
    userDiv: false,
    gridDiv: true,
    editUserDiv: false,
    saveDisabled: false
  };


  constructor(private systemService: SystemService, private messageService: MessageService, private utilService: UtilitiesService,
              private confirmationService: ConfirmationService, private cookieService: CookieService, private router: Router) { }

  ngOnInit() {
    this.userTypeList = this.userTypeListALL; // for NOW, let's default to ALL types (CoB + Assessor)
    this.displayState.gridDiv = false;
    this.displayState.userDiv = false;
    this.displayState.editUserDiv = false;
    let uRole = this.cookieService.get('userRole'); // get the role from login cookie
    if (uRole) {
      this.myRole = uRole;
    } else {
      uRole = this.myRole;
      }
    const userId = parseInt(this.cookieService.get('whoami'), 10);    // get user Id
    this.systemService.getUser(userId).subscribe(data => {
          if (data) {
              this.utilService.doAudit(data, 'getUser response:');
              this.myUser = data;
          }
    });
   // this.loadUserList();
  }

  loadUserList() {
      this.displayState.workingDiv = true;
      this.systemService.getUserList().subscribe (data => {
        this.appealsUserList = [];
        this.appealsUserList = data;
        this.displayState.workingDiv = false;
    });
  }

    saveRole() {
        if (this.myRole === '') {
            this.showToast({ severity: 'error', summary: '', detail: 'Must enter a Role' });
            return true;
        }
        this.utilService.doAudit(this.myUser, 'save Role:');
        this.utilService.doAudit(this.myRole, 'my Role:');
        this.myUser.userType = this.myRole;
        this.utilService.doAudit(this.myUser, 'User w/ new Role:');
        this.updateLocalRole();
/*         this.systemService.saveUser(this.myUser).subscribe (data => {
            this.showToast({severity: 'success', summary: '', detail: 'User data updated.'});
            this.updateLocalRole();
        }); */
    }

    updateLocalRole() {
        // update cookie with new role...
        this.cookieService.set('userRole', this.myUser.userType, 1, '/');
        this.utilService.saveSecLevel(this.myUser.userType);    // change security level in service to let TopBar Component know there was a change
        // route to Home page??
        this.router.navigate(['/home']);
    }

    validateUserData() {
    // validate required user data; base it on value of any element w/ prd-required class??
    if ((this.myUser.emailAddress === '') || (this.myUser.lastName === '') || (this.myUser.userType === '')) {
      return false;
    }
    return true;
  }

  clearLocalStore() {
    const userName = this.cookieService.get('userName');
    this.utilService.doAudit( userName, 'Clearing local storage for last applicant/agency; user:');
    localStorage.removeItem( userName + '-lastApplicant');
    localStorage.removeItem( userName + '-lastAgency');
  }
  checkDBConn() {
    this.utilService.checkDBConn().subscribe(data => {
      this.utilService.doAudit(data,'check access to Assessor db:');
      if (data) {
        alert('Got response from checkDBConn');
      } else {
        alert('No response from checkDBConn!');
      }
      return;
    })
  }
  cancelEntry() {
    this.router.navigate(['/home']);
    return true;
  }

  showToast(msg: Message) {
    this.messageService.add(msg);
  }

  clear() {
    this.messageService.clear();
  }

}
